// Si no tengo acceso al sessionStorage, uso una implementación en memoria

interface Storage {
	getItem(key: string): Nullable<string>;
	setItem(key: string, value: string): void;
	removeItem(key: string): void;
	getAllKeys(): string[];
}


const storage: Storage = window && window.sessionStorage
	? {
		getItem(key: string) {
			return window.sessionStorage[key];
		},
		setItem(key: string, value: string) {
			window.sessionStorage[key] = value;
		},
		removeItem(key: string) {
			window.sessionStorage.removeItem(key);
		},
		getAllKeys() {
			return Object.keys(window.sessionStorage);
		}
	}
	: (function () {
		const s: any = {};
		return {
			getItem(key: string): string {
				return s[key] || null;
			},
			setItem(key: string, value: string) {
				s[key] = value;
			},
			removeItem(key: string) {
				delete s[key];
			},
			getAllKeys() {
				return Object.keys(s);
			}
		};
	})();

export default storage;

